module.exports = __webpack_public_path__ + "img/司法取证ico.84be4620.png";